(function() {
	var Cache;
	WebBaseAprovLV.debug = ['dev', 'demo'].includes(WebBaseAprovLV.config.environment);
	// global config
	if (typeof(window.WebBaseAprovLV) === 'undefined') {
		window.WebBaseAprovLV = {};
	}

	WebBaseAprovLV.config = WebBaseAprovLV.config || {};
	WebBaseAprovLV.lang = WebBaseAprovLV.config.defaultLang || 'de';
	WebBaseAprovLV.i18n = {};
	WebBaseAprovLV.pagingWindow = 10;
	WebBaseAprovLV.version = {
		template: '2026-02-23T15:00:08.665Z',
		i18n: '2026-02-23T15:00:08.665Z'
	};

	Cache = (function() {
		function Cache() {
			this.count = 0;
			this.store = {};
		}
		Cache.prototype.get = function(key, callback) {
			if (key && key.length) {
				if (this.store[key]) {
					if (typeof callback === 'function') {
						callback.call(null, this.store[key]);
					}
					return this.store[key];
				}
			}
			return {
				timestamp: null,
				type: null,
				value: null
			};
		};
		Cache.prototype.set = function(key, value) {
			var old = null;
			if (key && key.length) {
				if (this.store[key]) {
					old = this.store[key];
				} else {
					// does not exist yet
					++this.count;
				}
				this.store[key] = {
					timestamp: (new Date).getTime(),
					type: key.match(/[^.]*/)[0],
					value: value
				};
			}
			return old || {
				timestamp: null,
				type: null,
				value: null
			};
		};
		Cache.prototype.del = function(key) {
			if (key && this.store[key]) {
				delete this.store[key];
				--this.count;
			}
			return null;
		};
		return Cache;
	})();
	WebBaseAprovLV.Cache = new Cache();

	// IE11 padstart fix
	if (!String.prototype.padStart) {
		String.prototype.padStart = function padStart(targetLength, padString) {
			targetLength = targetLength >> 0; //truncate if number or convert non-number to 0;
			padString = String((typeof padString !== 'undefined' ? padString : ' '));
			if (this.length > targetLength) {
				return String(this);
			} else {
				targetLength = targetLength - this.length;
				if (targetLength > padString.length) {
					padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
				}
				return padString.slice(0, targetLength) + String(this);
			}
		};
	}

	// global utils
	WebBaseAprovLV.Utils = {};
	WebBaseAprovLV.Utils.getTemplate = function(template) {
		return $.get(WebBaseAprovLV.config.templatesPath + template + '.ejs.html?v=' + WebBaseAprovLV.version.template);
	};

	WebBaseAprovLV.actTimeStamp = 0;
	WebBaseAprovLV.Utils.setActTimeStamp = function() {
		WebBaseAprovLV.actTimeStamp = new Date().getTime();
	};


	// default google maps Layer settings
	WebBaseAprovLV.Utils.getGoogleMapsLayerConfigByCodename = function(codeName) {
		let geoJsonLayerConfig = {
			style: {
				strokeWeight: 1,
				strokeOpacity: 0.4,
				fillColor: '#bbd565'
			}
		};
		switch (codeName) {
			default:
				geoJsonLayerConfig.url = 'https://static.provinz.bz.it/shared/widgets/googleMaps/provinz.json';
		}
		return geoJsonLayerConfig;
	};

	WebBaseAprovLV.Utils.getKKData = function(parameters, altProjectId) {
		if (WebBaseAprovLV.debug) {
			console.log(
				'%c---\n%cCall getKKData and reset resetLastUpdateDateTime after %c\n ' + parameters,
				WebBaseAprovLV.Utils.LastUpdateDateTime.styleBoldRed,
				WebBaseAprovLV.Utils.LastUpdateDateTime.styleBold,
				WebBaseAprovLV.Utils.LastUpdateDateTime.styleDefaultRed
			);
		}
		WebBaseAprovLV.Utils.LastUpdateDateTime.reset();

		var apiUrl = WebBaseAprovLV.config.apiUrl || '';
		var apiHeaders = WebBaseAprovLV.config.apiHeaders || {};
		if ((altProjectId || '').length) {
			apiUrl = apiUrl.replace(WebBaseAprovLV.config.projectId, altProjectId);
		} else if (WebBaseAprovLV.config.apiUrlPreview && WebBaseAprovLV.config.apiHeadersPreview) {
			apiUrl = WebBaseAprovLV.config.apiUrlPreview;
			apiHeaders = WebBaseAprovLV.config.apiHeadersPreview;
		}
		return $.ajax({
			url: (apiUrl + '/items' + parameters + '&system.language=' + WebBaseAprovLV.lang + '&language=' + WebBaseAprovLV.lang),
			type: 'GET',
			dataType: 'json',
			headers: apiHeaders
		});
	};
	WebBaseAprovLV.Utils.getTaxonomies = function(props, altProjectId) {
		var apiUrl = WebBaseAprovLV.config.apiUrl || '';
		var apiHeaders = WebBaseAprovLV.config.apiHeaders || {};
		if ((altProjectId || '').length) {
			apiUrl = apiUrl.replace(WebBaseAprovLV.config.projectId, altProjectId);
		} else if (WebBaseAprovLV.config.apiUrlPreview && WebBaseAprovLV.config.apiHeadersPreview) {
			apiUrl = WebBaseAprovLV.config.apiUrlPreview;
			apiHeaders = WebBaseAprovLV.config.apiHeadersPreview;
		}
		props = props || {};
		var groupname = props.groupname || '';
		if (groupname.length) {
			groupname = '/' + props.groupname;
		}
		return $.ajax({
			url: (apiUrl + '/taxonomies' + groupname),
			type: 'GET',
			dataType: 'json',
			headers: apiHeaders
		});
	};

	WebBaseAprovLV.Utils.getSearchData = function(parameters) {
		return $.getJSON(WebBaseAprovLV.config.noovleSearchApiUrl + parameters + '&callback=?');
	};

	WebBaseAprovLV.Utils.getReveSearchData = function(parameters) {
		return $.getJSON('https://api.integrations.services.siag.it/pub/cocweb/revesearch/aprov/api/' + parameters + '&wt=json');
	};

	WebBaseAprovLV.Utils.getServiceEditorData = function(parameters) {
		// var secaEndpoint = 'https://api.integrations.services.siag.it/pub/cocweb/serviceeditor/civis/api/';
		var secaEndpoint = 'https://api.integrations.services.siag.it/pub/cocweb/serviceeditor/civis/api/';
		return $.getJSON(secaEndpoint + parameters)
		.catch(function(jqxhr, textStatus, error) {
			var err = ('Request Failed: ' + textStatus + ', ' + error);
			return {error: err};
		});
	};

	/**
	 * NEW: Fetch services via Quelix search endpoint (JSONP) and normalize
	 *      to the legacy structure: { Items: [...], Total: n }
	 *
	 * @param {object} opts
	 * @param {string} opts.lang - portal lang ("de","it","en"...)
	 * @param {string} opts.site
	 * @param {string} opts.client
	 * @param {string[]} opts.ids - legacy service ids
	 * @returns {jqXHR} jQuery promise (resolved value is [data, status, xhr] in $.when)
	 */
	WebBaseAprovLV.Utils.getServiceEditorDataQuelix = function(opts) {
		opts = opts || {};
		var ids = (opts.ids || []).filter(function(x) { return x != null && String(x).trim().length > 0; });
		if (!ids.length) {
			return $.Deferred().resolve([{ Items: [], Total: 0 }]).promise();
		}
		var portalLang = (opts.lang || WebBaseAprovLV.lang || 'de').toLowerCase();
		var quelixLangMap = { de: 'd', it: 'it', en: 'en', lld: 'lld' };
		var quelixLang = quelixLangMap[portalLang] || portalLang;
		var baseUrl = 'https://api.integrations.services.siag.it/pub/cocweb/quelix/aprov/api/search';
		// requiredfields=CODICE_CIVIS_LEGACY:1033064|CODICE_CIVIS_LEGACY:1033067|...
		var requiredfields = ids
			.map(function(id) { return 'CODICE_CIVIS_LEGACY:' + String(id).trim(); })
			.join('|');		
		function first(arr) {
			return Array.isArray(arr) && arr.length ? arr[0] : '';
		}
		function asBoolString(val) {
			if (val === true) return 'True';
			if (val === false) return 'False';
			return String(val || '');
		}
		return $.ajax({
			url: baseUrl,
			dataType: 'jsonp',
			cache: true,
			timeout: opts.timeout || 15000,
			data: {
			site: opts.site || 'coll_newcivis_services_de',
			proxystylesheet: 'json',
			client: opts.client || 'civis_bz_de',
			lang: quelixLang,
			getfields: '*',
			num: '50',
			filter: 0,
			q: '',
			requiredfields: requiredfields
			}
		}).then(function(resp) {
			var res = (((resp || {}).GSP || {}).RES || {});
			var hits = res.R || [];
			var items = hits.map(function(hit) {
			var mt = hit.MT || {};
			var civisId = first(mt.URI) || '';
			var civisLegacyId = first(mt.CODICE_CIVIS_LEGACY) || '';
			var title = first(mt.SEHI_TITLE) || hit.T || '';
			// user first the full description because short description is often with html tags not even closed or with errors
			var shortDesc = first(mt.SEHI_DESC)|| hit.S  ||'';
			shortDesc = WebBaseAprovLV.Utils.stripDirtHtml(shortDesc);
			if (shortDesc.length > 350) shortDesc = shortDesc.slice(0, 347) + '..';
			var isOnline = asBoolString(first(mt.IS_ONLINE));
			var serviceType = (isOnline === 'True') ? 'EGOV' : 'INFO';
			return {
				id: civisId ? parseInt(civisId, 10) : null,
				legacyId: civisLegacyId ? parseInt(civisLegacyId, 10) : null,
				Organization: { id: null },
				Snippet: {
					title: title,
					serviceType: serviceType,
					shortDescription: shortDesc,
					relatedServicesCount: 0,
					resourceGroupsCount: 0
				}
			};
			
			}).filter(function(x) { return x.id != null; });
				// sort items by list of searched IDs
				items.sort(function(a, b) {
					var idxA = ids.indexOf(String(a.legacyId));
					var idxB = ids.indexOf(String(b.legacyId));
					return idxA - idxB;
				});
			return [{
			Items: items,
			Total: items.length
			}];
		}, function() {
			return [{
			Items: [],
			Total: 0
			}];
		});
	};

	WebBaseAprovLV.Utils.stripDirtHtml = function(input) {
		return String(input || '')		
		.replace(/<script[^>]*>[\s\S]*?<\/script>/gi, '')
		.replace(/<style[^>]*>[\s\S]*?<\/style>/gi, ' ')
		.replace(/<\/?[^>]+>/g, ' ')
		.replace(/&nbsp;/g, ' ')
		.replace(/##(\d+)##/g, ' ')
		.replace(/&amp;/g, '&')
		.replace(/&quot;/g, '"')
		.replace(/&#39;/g, "'")
		.replace(/&lt;/g, '<')
		.replace(/&gt;/g, '>')
		.replace(/\s+/g, ' ')
		.trim();
	};

	WebBaseAprovLV.Utils.getI18nData = function(parameters) {
		var params = parameters || {};
		var lang = params.lang || WebBaseAprovLV.lang;
		return WebBaseAprovLV.i18n[lang] ? $.Deferred().resolve(WebBaseAprovLV.i18n[lang]).then(function(i18n) { return [i18n]; }) : $.getJSON('i18n/' + lang + '.json?v=' + WebBaseAprovLV.version.i18n);
	};

	WebBaseAprovLV.Utils.fetchAsync = function(settings) {
		settings = $.extend({
			dataType: 'json',
			cache: true
		}, settings || {});
		return function(url, options) {
			options = $.extend(settings, options || {}, {
				url: url
			});
			return $.ajax(options);
		};
	};

	WebBaseAprovLV.Utils.formaStringToNumber = function(inputString, outputFormat = 'float') {
		if (inputString != null && inputString !== undefined && inputString.length > 0) {
			//replace all special chars and DOts from inputString
			inputString = inputString.replace(/[^0-9,-]/g, '').replace(',', '.');
			if (inputString.length === 0) {
				return;
			}
			if (outputFormat === 'int') {
				return parseInt(inputString.replace(',', '.'), 10);
			} else if (outputFormat === 'float') {
				return parseFloat(inputString.replace(',', '.'));
			} else {
				return inputString;
			}
		}
		return;
	};

	WebBaseAprovLV.Utils.formatDateTime = function(datetime, format) {
		var dttm;
		var options = {};
		format = format || '';
		if (typeof datetime === 'string') {
			// suppose it's a string
			dttm = datetime.length > 0 ? (new Date(datetime)) : (new Date());
		} else if (typeof datetime === 'number') {
			// suppose it's a timestamp
			dttm = datetime.setTime(datetime);
		} else if (Object.prototype.toString.call(datetime) === '[object Date]') {
			// suppose it's a Date object
			dttm = datetime;
		} else {
			// fallback
			dttm = new Date();
		}
		if (format == 'withtime') {
			options = {year: 'numeric', month: '2-digit', day: '2-digit', hour: 'numeric', minute: 'numeric'};
		} else if (format == 'long') {
			options = {weekday: 'long', year: 'numeric', month: 'long', day: '2-digit'};
		} else if (format == 'shortmonth') {
			options = {month: 'short'};
		} else if (format == 'longmonth') {
			options = {month: 'long'};	
		} else if (format == 'onlyday') {
			options = {day: '2-digit'};
		} else if (format == 'onlytime') {
			options = {hour: 'numeric', minute: 'numeric'};
		} else {
			options = {year: 'numeric', month: '2-digit', day: '2-digit'};
		}
		if ((WebBaseAprovLV.config.usesLegacyDateUntil || '').length > 0 && (new Date(WebBaseAprovLV.config.usesLegacyDateUntil)) > dttm) {
			options.timeZone = 'UTC';
		}
		if (format == 'onlytime') {
			return dttm.toLocaleTimeString(WebBaseAprovLV.lang + '-IT', options);
		} else {
			return dttm.toLocaleDateString(WebBaseAprovLV.lang + '-IT', options);
		}
	};

	WebBaseAprovLV.Utils.getUrlParameter = function(name) {
		var regex;
		var results;
		name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
		regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
		results = regex.exec(location.search);
		return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
	};

	WebBaseAprovLV.Utils.text_truncate = function(str, length, ending) {
		if (length == null) {
			length = 100;
		}
		if (ending == null) {
			ending = '...';
		}
		if (str.length > length) {
			return str.substring(0, length - ending.length) + ending;
		} else {
			return str;
		}
	};

	WebBaseAprovLV.Utils.resolveBlankString = function(pGer, pIta, pLld) {
		if ((typeof pGer === 'string') || (typeof pIta === 'string') || (typeof pLld === 'string')) {
			if (WebBaseAprovLV.lang == 'it') {
				if (pIta != null) {
					return pIta.replace(/\n/g, '<br />');
				}
			} else if (WebBaseAprovLV.lang == 'lld') {
				if (pLld != null) {
					return pLld.replace(/\n/g, '<br />');
				}
			} else {
				if (pGer != null) {
					return pGer.replace(/\n/g, '<br />');
				}
			}
		} else if ((typeof pGer === 'number') || (typeof pIta === 'number') || (typeof pLld === 'number')) {
			if (WebBaseAprovLV.lang == 'it') {
				if (pIta != null) {
					return pIta;
				}
			} else if (WebBaseAprovLV.lang == 'lld') {
				if (pLld != null) {
					return pLld;
				}
			} else {
				if (pGer != null) {
					return pGer;
				}
			}
		}
	};


	WebBaseAprovLV.Utils.getCollectionBPyageSlugAndMenu = function(pageUrl, mainMenuContainer) {
		let collection = 'default';
		mainMenuContainer.forEach(function(menuPage) {
			if (menuPage.url === pageUrl) {
				return menuPage.system_collection;
			} else {
				if (typeof menuPage.subpages === 'object' && menuPage.subpages !== null && Object.keys(menuPage.subpages).length > 0) {
					WebBaseAprovLV.Utils.getCollectionBPyageSlugAndMenu(pageUrl, menuPage.subpages);
				}
			}
		});
		return collection;
	};

	WebBaseAprovLV.Utils.groupBy = function(list, keyGetter) {
		var map = new Map();
		list.forEach(function(item) {
			var key = keyGetter(item);
			var collection = map.get(key);
			if (!collection) {
				map.set(key, [item]);
			} else {
				collection.push(item);
			}
		});
		return map;
	};

	WebBaseAprovLV.Utils.replaceUrlParam = function(url, paramName, paramValue) {
		var pattern = new RegExp('\\b(' + (paramName || '') + '=).*?(&|#|$)');
		url = url || '';
		if ('number' === typeof paramValue) {
			paramValue = paramValue.toString(10);
		}
		if (Array.isArray(paramValue) || 'object' === typeof paramValue) {
			paramValue = encodeURIComponent(JSON.stringify(paramValue));
		}
		paramValue = paramValue || '';
		if (url.search(pattern) >= 0) {
			return url.replace(pattern, '$1' + paramValue + '$2');
		}
		url = url.replace(/[?#]$/, '');
		return url + (url.length > 0 ? '&' : '') + (paramName || '') + '=' + paramValue;
	};
	/**
	 * Fix Double Encoding / Facetted Search Comparison
	 */
	WebBaseAprovLV.Utils.quelixDoubleEncodeFix = function(inputString) {
		var replacements = {
			':': '%3A',
			'%7C': '%257C',
			'%C3%BC': '%25C3%25BC',
			'%C3%96': '%25C3%2596',
			'%20': '%2520',
			'%C3%AB': '%25C3%25AB',
			'%C3%A4': '%25C3%25A4',
			'%C3%B6': '%25C3%25B6',
			'%C3%84': '%25C3%2584',
			'%C3%9C': '%25C3%259C',
			'%C3%AC': '%25C3%25AC',
			'%2F': '%252F',
			'%2C': '%252C',
			'%26': '%2526',
			'%3B': '%253B',
			'%C3%A0': '%25C3%25A0',
			'%C3%A1': '%25C3%25A1',
			'%C2%B4': '%25C2%25B4',
			'%E2%80%99': '%25E2%2580%2599',
			'%C3%B9': '%25C3%25B9',
			'%C3%9F': '%25C3%259F',
			'%C4%87': '%25C4%2587',
			'%C3%A9': '%25C3%25A9',
			'\'': '%2527',
			'\\(': '%2528',
			'\\)': '%2529'
		};
		for (var key in replacements) {
			if (replacements.hasOwnProperty(key)) {
				inputString = inputString.replace(new RegExp(key, 'g'), replacements[key]);
			}
		}
		return inputString;
	};

	WebBaseAprovLV.Utils.getLanguageHash = function(name) {
		var matches = location.hash.match(new RegExp(name || ''));
		return matches ? matches[0] : null;
	};
	/**
	 * Parse query string
	 * @param {string} querystring - The query string
	 * @returns {object} Pairs
	 * @example
	 * WebBaseAprovLV.Utils.parseQuerystring("?foo=Fritz&bar=Muster");
	 */
	WebBaseAprovLV.Utils.parseQuerystring = function(querystring, keyFormatFn) {
		var args = {};
		keyFormatFn = 'function' === typeof keyFormatFn ? keyFormatFn : function(key) {
			return (key || '');
		};
		var qs = querystring && querystring.length > 0 && querystring[0] === '?' ? querystring.substring(1) : querystring || '';
		qs.split('&').forEach(function(item) {
			var kv = item.split(/=/);
			var k = keyFormatFn(kv[0] || '');
			if (k.length) {
				args[k] = kv[1] || '';
			}
		});
		return args;
	};
	/**
	 * Basic i18n gettext - translate a string
	 * @example
	 * WebBaseAprovLV.Utils.gettext("More");
	 */
	WebBaseAprovLV.Utils.gettext = function(msgid) {
		var i18n = WebBaseAprovLV.i18n;
		var lang = WebBaseAprovLV.lang || 'de';
		var dict = i18n ? i18n[lang] : null;
		return (dict && dict[msgid]) ? dict[msgid] : msgid;
	};
	/**
	 * Adjust the target urls of the language switching links
	 * @example
	 * WebBaseAprovLV.Utils.tuneUILangSwitchers(pageContent.items[0], $('a.langchange'));
	 */
	WebBaseAprovLV.Utils.tuneUILangSwitchers = function(props, $el) {
		var authorities = /prod/i.test(WebBaseAprovLV.config.environment || '') ? (WebBaseAprovLV.config.authorities || {}) : {};
		var hash = window.location.hash || '';
		props = props || {};
		props.page = props.page || {};
		// segment names:  /{lang}/{ page segment name }/{ detail segment name }
		function getLinkSegment(part, lang) {
			var ret = '';
			var params = [];
			lang = lang || WebBaseAprovLV.lang;
			if ('object' === typeof part.segment) {
				// if segment is language map, get segment of specific lang
				if ((part.segment[lang] || '').length) {
					ret = part.segment[lang];
				}
			} else if ('string' === typeof part.segment) {
				ret = part.segment;
			} else {
				// if segment is not known or not defined
				if ((part.id || '').length) {
					params.push('system.id=' + encodeURIComponent(part.id));
				}
				if ((part.project_id || '').length) {
					params.push('project.id=' + encodeURIComponent(part.project_id));
				}
				ret = params.join('&');
			}
			return ret;
		}
		($el || $('a.langchange')).each(function() {
			var $that = $(this);
			var lang = ($that.attr('hreflang') || WebBaseAprovLV.lang);
			var segment = getLinkSegment(props.page, lang);	// page segment
			if (segment.length && props.detail && (!!props.detail.id || !!props.detail.segment)) {
				segment = segment + '/' + getLinkSegment(props.detail, lang); // detail segment
			}
			if (segment.length === 0) {
				segment = 'home';
			}
			if (WebBaseAprovLV && WebBaseAprovLV.config && WebBaseAprovLV.config.handOverHashLangSwitch) {
				segment += hash;
			}
			$that.attr('href', [((authorities[lang] || '') + lang), segment].join('/'));
		});
		return props;
	};
	/**
	 * Get CSS class name of specific mime type. Note: It is project and CSS dependant.
	 * @param {string} mimetype - The mime type
	 * @returns {string} CSS class name
	 * @example
	 * var cssClass = WebBaseAprovLV.Utils.getMimetypeClassName("application/pdf");
	 */
	WebBaseAprovLV.Utils.getMimetypeClassName = function(mimetype) {
		var mime = mimetype || '';
		switch (true) {
			case /^application/i.test(mime):
				switch (true) {
					case /pdf$/.test(mime):
						return 'pdf';
					case /(word|rtf|opendocument\.text)/i.test(mime):
						return 'doc';
					case /(xls|excel|spreadsheet)/i.test(mime):
						return 'xls';
					case /(ppt|powerpoint|presentation)/i.test(mime):
						return 'ppt';
					case /(zip)/i.test(mime):
						return 'zip';
				}
				break;
			case /^text/i.test(mime):
				switch (true) {
					case /html$/.test(mime):
						return 'htm';
					case /(rtf|sgml|troff)$/.test(mime):
						return 'doc';
					case /(xml|csv)/i.test(mime):
						return 'xls';
				}
				break;
			case /^image/i.test(mime):
				return 'img';
			case /^audio/i.test(mime):
				return 'audio';
			case /^video/i.test(mime):
				return 'video';
		}
		return 'other';	// default, other, not classified
	};
	/**
	 * Remove dangerous characters from text and encode double and single quotes for attribute usage (xss)
	 * @param {string||number} attr - The string or number
	 * @returns {text} The cleaned string
	 */
	WebBaseAprovLV.Utils.toSafeAttribute = function(attr) {
		if ('string' === typeof attr && attr.length) {
			return attr.replace(/[\x00-\x1f\x3c\x3e"]/igm, '').replace(/\x22/g, '&quot;').replace(/\x27/g, '&#39;');
		}
		if ('number' === typeof attr) {
			return attr.toString(attr, 10);
		}
		return '';
	};
	/**
	 * Format bytes as human-readable text.
	 *
	 * @param bytes Number of bytes.
	 * @param si True to use metric (SI) units (1000), or binary (IEC) units (1024).
	 * @param dp Number of decimal places to display.
	 *
	 * @return Formatted string.
	 */
	WebBaseAprovLV.Utils.toHumanFileSize = function(bytes, si, dp) {
		var base;
		var units;
		var u = -1;
		var rem;
		si = !!si;
		dp = isNaN(dp) ? 0 : dp;
		base = si ? 1000 : 1024;
		units = si
			? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
			: ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
		rem = Math.pow(10, dp);
		if (Math.abs(bytes) < base) {
			return bytes + ' B';
		}
		do {
			bytes /= base;
			++u;
		} while ((Math.round(Math.abs(bytes) * rem) / rem) >= base && u < units.length - 1);
		return bytes.toFixed(dp) + ' ' + (units[u] || '');
	};
	/**
	 * Translate link dependent on environment or other circumstances.
	 * @param {string} link - The link
	 * @returns {string} The transformed link
	 * @example
	 * var cssClass = WebBaseAprovLV.Utils.linkTo('/de/page');
	 */
	WebBaseAprovLV.Utils.linkTo = function(link) {
		// return /dev/i.test(WebBaseAprovLV.config.environment) ? ('#!' + link) : link;
		return link;
	};
	/**
	 * Translate action attribute dependent on environment or other circumstances.
	 * @param {string} link - The link
	 * @returns {string} The transformed link
	 * @example
	 * var cssClass = WebBaseAprovLV.Utils.actionTo('/de/page');
	 */
	WebBaseAprovLV.Utils.actionTo = function(link) {
		// return /dev/i.test(WebBaseAprovLV.config.environment) ? ('#!' + link) : link;
		return link;
	};

	/**
	 * Load template and render contents
	 * @param {object} options - Template, data and target element
	 * @returns {object} Promise
	 */
	WebBaseAprovLV.Utils.transitionTo = function(options) {
		return ejs.preloadTemplate(options.template)
		.then(function() {
			options.element.html(ejs.rr(options.template, options.data));
			return options;
		}).promise();
	};

	WebBaseAprovLV.Utils.LastUpdateDateTime = {
		styleBold: 'color:black; font-size:12px; font-weight:bold;',
		styleBoldGreen: 'color:#06cf94; font-size:12px; font-weight:bold;',
		styleBoldRed: 'color:red; font-size:12px; font-weight:bold;',
		styleBoldYellow: 'color:#f9d200; font-size:12px; font-weight:bold;',
		styleDefaultGreen: 'color:#06cf94; font-size:11px;font-weight:normal;',
		styleDefaultRed: 'color:red; font-size:11px;font-weight:normal;',
		styleDefaultYellow: 'color:#f9d200; font-style:italic; font-size:11px;font-weight:normal;'
	};

	/**
	 * reset LastUpdateDateTime
	 * @returns void
	 */
	WebBaseAprovLV.Utils.LastUpdateDateTime.reset = function() {
		//console.log('resetLastUpdateDateTime called');
		$('#lastUpdateBox').html('');
	};

	/**
	 * set lastUpdate in template
	 * @param {string} lastUpdateBoxText
	 * @returns void
	 */
	WebBaseAprovLV.Utils.LastUpdateDateTime.setDateTime = function(lastUpdateBoxText = '') {
		//console.log('LastUpdateDateTime.setDateTime called');
		$('#lastUpdateBox').html(lastUpdateBoxText);
	};

	/**
	 * set calc last update
	 * @param {array} elementsArr
	 * @param {string} lastUpdateDate
	 */
	WebBaseAprovLV.Utils.LastUpdateDateTime.calc = function(lastUpdateDate = '', elementsArr = []) {
		if (elementsArr.length !== 0) {
			let possibleContentTypes = {
				'homepage': 'default',
				'page': 'default',
				'icon_box_container': 'container',
				'icon_box_item': 'default',
				'box_container': 'container',
				'box_item': 'default',
				'image_and_text_section': 'default',
				'hilite_section': 'default',
				'serviceeditor_section': 'default',
				'collapse_container': 'container',
				'postcard_container': 'container',
				'postcard_item': 'default',
				'collapse_item': 'default',
				'news_homepage': 'default',
				'news_container': 'container',
				'news': 'default',
				'appointment_container': 'container',
				'appointment_item': 'default',
				'project_item': 'default',
				'youtube_video_item': 'default',
				'introduction_section': 'default',
				'serviceeditor_section': 'default'
			};
			for (key in elementsArr) {
				let item = elementsArr[key];
				// special content from search engine
				if (item && item.hasOwnProperty('MT') && item.MT.hasOwnProperty('documentType') && possibleContentTypes.hasOwnProperty(item.MT.documentType[0])) {
					lastUpdateDate = WebBaseAprovLV.Utils.LastUpdateDateTime.evaluateDateTime(
						{
							'system_type': item.MT.documentType[0],
							'date': item.MT.date[0],
							'script_report_results': item.script_report_results
						},
						lastUpdateDate
					);
				} else if (item && item.hasOwnProperty('system') && possibleContentTypes.hasOwnProperty(item.system.type)) {
					if (possibleContentTypes[item.system.type] === 'container') {
						for (containerItemKey in item.container) {
							lastUpdateDate = WebBaseAprovLV.Utils.LastUpdateDateTime.evaluateDateTime(item.container[containerItemKey].system, lastUpdateDate);
						}
					} else {
						lastUpdateDate = WebBaseAprovLV.Utils.LastUpdateDateTime.evaluateDateTime(item, lastUpdateDate);
					}
				} else {
					if (item && item.hasOwnProperty('system_type') && possibleContentTypes.hasOwnProperty(item.system_type)) {
						if (possibleContentTypes[item.system_type] === 'container') {
							for (containerItemKey in item.container) {
								if (possibleContentTypes.hasOwnProperty(item.container[containerItemKey].system_type)) {
									lastUpdateDate = WebBaseAprovLV.Utils.LastUpdateDateTime.evaluateDateTime(item.container[containerItemKey], lastUpdateDate);
								}
							}
						} else {
							lastUpdateDate = WebBaseAprovLV.Utils.LastUpdateDateTime.evaluateDateTime(item, lastUpdateDate);
						}
					}
				}
			}
		};
		return lastUpdateDate;
	};

	/**
	 * evaluate  last update time and get back the newsest
	 * @param {array} elementsArr
	 * @param {string} lastUpdateDate
	 * @returns {string} lastUpdateDate
	 */
	WebBaseAprovLV.Utils.LastUpdateDateTime.evaluateDateTime = function(item, lastUpdateDate) {
		let checkDate = '';
		let systemType = item.system_type ? item.system_type : item.system.type;
		let systemId = item.script_report_results
			? item.script_report_results
			: (item.hasOwnProperty('system_id') ? item.system_id : item.system.id);
		if (systemType === 'news') {
			checkDate = item.hasOwnProperty('elements')
				? item.elements.date.value
				: item.date;
		} else {
			checkDate = item.system_last_modified;
		}

		// create date time tomorrow at 00:01
		let tomorrowDate = new Date();
		tomorrowDate.setDate(tomorrowDate.getDate() + 1);
		tomorrowDate.setUTCHours(0, 0, 0, 0);
		let todayAtMidnightDate = tomorrowDate.toISOString().slice(0, 19) + 'Z';

		// create date time one year ago
		let oneYearAgo = new Date();
		oneYearAgo.setFullYear(new Date().getFullYear() - 1);
		oneYearAgo.setUTCHours(0, 0, 0, 0);
		let oneYearAgoDate = oneYearAgo.toISOString().slice(0, 19) + 'Z';

		// check if date is not older then 1 year, not newer today and higher then last last date
		if (checkDate > oneYearAgoDate && checkDate < todayAtMidnightDate && checkDate > lastUpdateDate) {
			if (WebBaseAprovLV.debug) {
				console.log(
					'%c+++\n%cCheck date: %c' + checkDate + ' %cis newer than: %c' + (lastUpdateDate ? lastUpdateDate : 'null')
					+ ' %c\nItem_type: %c' + systemType + ' %c\nItem_id: %c' + systemId,
					WebBaseAprovLV.Utils.LastUpdateDateTime.styleBoldGreen,
					WebBaseAprovLV.Utils.LastUpdateDateTime.styleBold,
					WebBaseAprovLV.Utils.LastUpdateDateTime.styleDefaultGreen,
					WebBaseAprovLV.Utils.LastUpdateDateTime.styleBold,
					WebBaseAprovLV.Utils.LastUpdateDateTime.styleDefaultGreen,
					WebBaseAprovLV.Utils.LastUpdateDateTime.styleBold,
					WebBaseAprovLV.Utils.LastUpdateDateTime.styleDefaultGreen,
					WebBaseAprovLV.Utils.LastUpdateDateTime.styleBold,
					WebBaseAprovLV.Utils.LastUpdateDateTime.styleDefaultGreen
				);
			}
			return checkDate;
		} else {
			if (WebBaseAprovLV.debug) {
				let comparsionOperatorLabel = checkDate > todayAtMidnightDate ? 'is in future than: ' : 'is older than: ';
				console.log(
					'%c~~~\n%cCheck date: %c' + checkDate + ' %c' + comparsionOperatorLabel + '%c' + (lastUpdateDate ? lastUpdateDate : 'null')
					+ ' %c\nItem_type: %c' + systemType + ' %c\nItem_id: %c' + systemId,
					WebBaseAprovLV.Utils.LastUpdateDateTime.styleBoldYellow,
					WebBaseAprovLV.Utils.LastUpdateDateTime.styleBoldYellow,
					WebBaseAprovLV.Utils.LastUpdateDateTime.styleDefaultYellow,
					WebBaseAprovLV.Utils.LastUpdateDateTime.styleBoldRed,
					WebBaseAprovLV.Utils.LastUpdateDateTime.styleDefaultYellow,
					WebBaseAprovLV.Utils.LastUpdateDateTime.styleBoldYellow,
					WebBaseAprovLV.Utils.LastUpdateDateTime.styleDefaultYellow,
					WebBaseAprovLV.Utils.LastUpdateDateTime.styleBoldYellow,
					WebBaseAprovLV.Utils.LastUpdateDateTime.styleDefaultYellow
				);
			}
		}
		return lastUpdateDate;
	};

	/**
	 * calculate lastUpdate date and render it in template
	 * @param {object} pageRaw - pageRaw data
	 * @param {object} specialContent - specialContent data
	 * @param {string} calcUpdateTimeType - calcUpdateTimeType, type how data will be calculated,
	 * 		defaultAndSpecial => use pageRaw, page default contents and special content
	 * 		onlySpecial => use only special content
	 */
	WebBaseAprovLV.Utils.LastUpdateDateTime.calcAndShow = function(pageRaw, specialContent, calcUpdateTimeType = 'defaultAndSpecial') {
		// first at all resetLastUpdateDateTime
		WebBaseAprovLV.Utils.LastUpdateDateTime.reset();

		let lastUpdateDate = '';
		let defaultLabel = {
			'prefix': {
				'de': 'Letzte Aktualisierung:',
				'it': 'Ultimo aggiornamento:',
				'en': 'Last updated:',
				'lld': 'Ultimo ajornamënt:'
			},
			'today': {
				'de': ' Heute',
				'it': ' Oggi',
				'en': ' Today',
				'lld': ' Incö'
			}
		};

		switch (calcUpdateTimeType) {
			case 'defaultAndSpecial':
				// page model
				lastUpdateDate = WebBaseAprovLV.Utils.LastUpdateDateTime.calc(lastUpdateDate, [pageRaw]);
				// default page content models
				lastUpdateDate = WebBaseAprovLV.Utils.LastUpdateDateTime.calc(lastUpdateDate, pageRaw.pageContent);
				// homepage content models
				lastUpdateDate = WebBaseAprovLV.Utils.LastUpdateDateTime.calc(lastUpdateDate, pageRaw.container);
				// default content models
				lastUpdateDate = WebBaseAprovLV.Utils.LastUpdateDateTime.calc(lastUpdateDate, pageRaw.modular_content);

				// special content models like news_homepage
				for (key in specialContent) {
					if (specialContent && specialContent[key] && specialContent[key].hasOwnProperty('raw') && specialContent[key].raw.hasOwnProperty('items')) {
						lastUpdateDate = WebBaseAprovLV.Utils.LastUpdateDateTime.calc(lastUpdateDate, specialContent[key].raw.items);
					} else if (
						specialContent
						&& specialContent[key]
						&& specialContent[key].hasOwnProperty('raw')
						&& specialContent[key].raw.hasOwnProperty('GSP')
						&& specialContent[key].raw.GSP.hasOwnProperty('RES')
					) {
						lastUpdateDate = WebBaseAprovLV.Utils.LastUpdateDateTime.calc(lastUpdateDate, specialContent[key].raw.GSP.RES['R']);
					} else {
						lastUpdateDate = WebBaseAprovLV.Utils.LastUpdateDateTime.calc(lastUpdateDate, specialContent);
					}
				}
				break;
			case 'onlySpecial':
				// special content models
				for (key in specialContent) {
					if (specialContent[key].hasOwnProperty('raw')) {
						lastUpdateDate = WebBaseAprovLV.Utils.LastUpdateDateTime.calc(lastUpdateDate, specialContent[key].raw.items);
					} else {
						lastUpdateDate = WebBaseAprovLV.Utils.LastUpdateDateTime.calc(lastUpdateDate, specialContent);
					}
				}
				break;
		};

		let lastUpdateBoxText = '';
		if (lastUpdateDate !== '') {
			let today = new Date();
			// create date obj an remove 1 hour because utc +1
			let lastUpdateDateObject = new Date(new Date(lastUpdateDate).getTime() - 60 * 60 * 1000);
			let lastUpdateDateFormatted = (today.toDateString() === lastUpdateDateObject.toDateString())
				? defaultLabel['today'][(/^(de|it|en|lld)$/.test(WebBaseAprovLV.lang) ? WebBaseAprovLV.lang : 'de')]
				: lastUpdateDateObject.toISOString().replace(/T.*/, '').split('-').reverse().join('/');

			lastUpdateBoxText = '<div class="updates"><div class="container"><div class="row"><p class="pl-2"><em>'
				+ defaultLabel['prefix'][(/^(de|it|en|lld)$/.test(WebBaseAprovLV.lang) ? WebBaseAprovLV.lang : 'de')] + ' '
				+ lastUpdateDateFormatted
				+ '</em></p></div></div></div>';
		}
		WebBaseAprovLV.Utils.LastUpdateDateTime.setDateTime(lastUpdateBoxText);
	};

	/**
	 * Manual scroll restoration for the client side router.
	 *
	 * page.js renders routes asynchronously and the browser cannot reliably restore
	 * scroll positions while the old DOM is replaced by EJS templates. Therefore we
	 * keep the current scroll position in the active history entry and restore it
	 * only for real browser Back/Forward navigations.
	 */
	WebBaseAprovLV.Utils.ScrollHistory = (function() {
		var STATE_KEY = 'WebBaseAprovLVScroll';
		var initialized = false;
		var popstateNavigation = false;
		var pendingRestore = null;
		var saveTimer = null;
		var suppressScrollSaveUntil = 0;
		var activeRestoreId = 0;

		function now() {
			return (new Date()).getTime();
		}

		function currentPath() {
			return window.location.pathname + window.location.search + window.location.hash;
		}

		function normalizePath(path) {
			path = (path || currentPath()).toString();
			path = path.replace(/^https?:\/\/[^/]+/i, '');
			if (!path.length) {
				path = '/';
			}
			return path;
		}

		function pathMatchesCurrent(path) {
			return normalizePath(path) === normalizePath(currentPath());
		}

		function createId() {
			return [STATE_KEY, now(), Math.floor(Math.random() * 1000000)].join('-');
		}

		function requestFrame(callback) {
			return (window.requestAnimationFrame || function(fn) {
				return setTimeout(fn, 16);
			})(callback);
		}

		function getScrollPosition() {
			var doc = document.documentElement || {};
			var body = document.body || {};
			return {
				x: window.pageXOffset || doc.scrollLeft || body.scrollLeft || 0,
				y: window.pageYOffset || doc.scrollTop || body.scrollTop || 0
			};
		}

		function getDocumentHeight() {
			var doc = document.documentElement || {};
			var body = document.body || {};
			return Math.max(
				body.scrollHeight || 0,
				doc.scrollHeight || 0,
				body.offsetHeight || 0,
				doc.offsetHeight || 0,
				body.clientHeight || 0,
				doc.clientHeight || 0
			);
		}

		function maxScrollTop() {
			return Math.max(0, getDocumentHeight() - (window.innerHeight || document.documentElement.clientHeight || 0));
		}

		function cloneState(state) {
			return $.extend(true, {}, state || {});
		}

		function getMetaFromState(state) {
			return (state || {})[STATE_KEY] || null;
		}

		function storageKey(idOrPath) {
			return STATE_KEY + ':' + idOrPath;
		}

		function rememberInSession(meta) {
			if (!window.sessionStorage || !meta) {
				return;
			}
			try {
				if (meta.id) {
					sessionStorage.setItem(storageKey(meta.id), JSON.stringify(meta));
				}
				if (meta.path) {
					sessionStorage.setItem(storageKey(meta.path), JSON.stringify(meta));
				}
			} catch (e) {}
		}

		function readFromSession(idOrPath) {
			var item;
			if (!window.sessionStorage || !idOrPath) {
				return null;
			}
			try {
				item = sessionStorage.getItem(storageKey(idOrPath));
				return item ? JSON.parse(item) : null;
			} catch (e) {
				return null;
			}
		}

		function replaceCurrentScrollState(position, forcePath) {
			var state;
			var meta;
			var pos = position || getScrollPosition();
			if (!window.history || !window.history.replaceState) {
				return null;
			}
			state = cloneState(window.history.state || {});
			meta = $.extend({}, getMetaFromState(state) || {});
			meta.id = meta.id || createId();
			meta.path = normalizePath(forcePath || currentPath());
			meta.x = Math.max(0, Math.round(pos.x || 0));
			meta.y = Math.max(0, Math.round(pos.y || 0));
			meta.updatedAt = now();
			state[STATE_KEY] = meta;
			try {
				window.history.replaceState(state, document.title, window.location.href);
				rememberInSession(meta);
			} catch (e) {}
			return meta;
		}

		function saveCurrentPosition() {
			if (now() < suppressScrollSaveUntil) {
				return;
			}
			replaceCurrentScrollState(getScrollPosition(), currentPath());
		}

		function scheduleSaveCurrentPosition() {
			if (now() < suppressScrollSaveUntil) {
				return;
			}
			clearTimeout(saveTimer);
			saveTimer = setTimeout(saveCurrentPosition, 150);
		}

		function normalizeMeta(meta) {
			if (!meta) {
				return null;
			}
			return {
				x: Math.max(0, Math.round(meta.x || 0)),
				y: Math.max(0, Math.round(meta.y || 0)),
				path: normalizePath(meta.path || currentPath()),
				id: meta.id || null
			};
		}

		function getMetaForContext(ctx) {
			var meta = normalizeMeta(getMetaFromState((ctx || {}).state));
			if (meta && pathMatchesCurrent(meta.path)) {
				return meta;
			}
			meta = normalizeMeta(getMetaFromState(window.history ? window.history.state : null));
			if (meta && pathMatchesCurrent(meta.path)) {
				return meta;
			}
			return normalizeMeta(readFromSession(currentPath()));
		}

		function cancelActiveRestore() {
			activeRestoreId += 1;
			pendingRestore = null;
			suppressScrollSaveUntil = 0;
		}

		function jumpTo(position, saveState) {
			var x = Math.max(0, Math.round((position || {}).x || 0));
			var y = Math.max(0, Math.round((position || {}).y || 0));
			suppressScrollSaveUntil = now() + 250;
			if ($('html, body').stop) {
				$('html, body').stop(true, true);
			}
			window.scrollTo(x, y);
			$('html, body').scrollTop(y);
			setTimeout(function() {
				suppressScrollSaveUntil = 0;
				if (saveState) {
					replaceCurrentScrollState(getScrollPosition(), currentPath());
				}
			}, 80);
		}

		function getAnchorOffset() {
			var windowSizeWide = $(window).width();
			if (windowSizeWide <= 576) {
				return 110;
			}
			if (windowSizeWide <= 991) {
				return 133;
			}
			return 133;
		}

		function getHashTarget(hash) {
			var anchorName;
			var elementById;
			if (!hash || hash === '#') {
				return $();
			}
			try {
				anchorName = decodeURIComponent(hash.replace(/^#/, ''));
			} catch (e) {
				anchorName = hash.replace(/^#/, '');
			}
			elementById = document.getElementById(anchorName);
			if (elementById) {
				return $(elementById);
			}
			return $('[name]').filter(function() {
				return this.getAttribute('name') === anchorName;
			}).first();
		}

		function scrollToHashWhenReady(hash) {
			var startedAt = now();
			var timeout = 1500;
			var restoreId = ++activeRestoreId;
			var restorePath = currentPath();
			function tryScroll() {
				var target;
				var scrollTop;
				if (restoreId !== activeRestoreId || normalizePath(restorePath) !== normalizePath(currentPath())) {
					return;
				}
				target = getHashTarget(hash);
				if (target.length) {
					scrollTop = Math.max(0, target.offset().top - getAnchorOffset());
					jumpTo({ x: 0, y: scrollTop }, true);
					return;
				}
				if (now() - startedAt < timeout) {
					requestFrame(tryScroll);
				} else {
					replaceCurrentScrollState(getScrollPosition(), currentPath());
				}
			}
			tryScroll();
		}

		function restorePositionWhenReady(position) {
			var x = Math.max(0, Math.round((position || {}).x || 0));
			var y = Math.max(0, Math.round((position || {}).y || 0));
			var startedAt = now();
			var timeout = 1500;
			var restoreId = ++activeRestoreId;
			var restorePath = normalizePath((position || {}).path || currentPath());

			if (!pathMatchesCurrent(restorePath)) {
				return;
			}
			suppressScrollSaveUntil = now() + timeout + 250;
			function tryRestore() {
				var canReachTarget;
				if (restoreId !== activeRestoreId || !pathMatchesCurrent(restorePath)) {
					return;
				}
				canReachTarget = maxScrollTop() >= y;
				window.scrollTo(x, y);
				if (!canReachTarget && now() - startedAt < timeout) {
					requestFrame(tryRestore);
					return;
				}
				suppressScrollSaveUntil = now() + 100;
				setTimeout(function() {
					if (restoreId !== activeRestoreId || !pathMatchesCurrent(restorePath)) {
						return;
					}
					suppressScrollSaveUntil = 0;
					replaceCurrentScrollState(getScrollPosition(), currentPath());
				}, 120);
			}
			requestFrame(tryRestore);
		}

		function isPageJsHandledLink(anchor) {
			var href;
			if (!anchor || !anchor.href) {
				return false;
			}
			if (anchor.target || anchor.hasAttribute('download')) {
				return false;
			}
			href = anchor.getAttribute('href') || '';
			if (!href.length || /^#/.test(href) || /^(mailto|tel):/i.test(href)) {
				return false;
			}
			return anchor.protocol === window.location.protocol && anchor.host === window.location.host;
		}

		function findLinkTarget(element) {
			while (element && element !== document) {
				if (element.tagName && element.tagName.toLowerCase() === 'a') {
					return element;
				}
				element = element.parentNode;
			}
			return null;
		}

		function init() {
			if (initialized) {
				return;
			}
			initialized = true;
			if (window.history && 'scrollRestoration' in window.history) {
				window.history.scrollRestoration = 'manual';
			}
			setTimeout(function() {
				replaceCurrentScrollState(getScrollPosition(), currentPath());
			}, 0);
			$(window).on('scroll.WebBaseAprovLVScrollHistory', scheduleSaveCurrentPosition);
			$(window).on('beforeunload.WebBaseAprovLVScrollHistory pagehide.WebBaseAprovLVScrollHistory', saveCurrentPosition);
			document.addEventListener('click', function(event) {
				var anchor;
				if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button) {
					return;
				}
				anchor = findLinkTarget(event.target);
				if (isPageJsHandledLink(anchor)) {
					saveCurrentPosition();
					cancelActiveRestore();
				}
			}, true);
			window.addEventListener('popstate', function(event) {
				var meta;
				popstateNavigation = true;
				cancelActiveRestore();
				meta = normalizeMeta(getMetaFromState(event.state));
				pendingRestore = (meta && pathMatchesCurrent(meta.path)) ? meta : normalizeMeta(readFromSession(currentPath()));
			});
		}

		return {
			init: init,
			beforeRoute: function(ctx) {
				var isHistoryNavigation;
				var meta;
				init();
				isHistoryNavigation = popstateNavigation;
				popstateNavigation = false;
				cancelActiveRestore();

				if (!isHistoryNavigation) {
					pendingRestore = null;
							jumpTo({ x: 0, y: 0 }, true);
					return;
				}

				meta = pendingRestore || getMetaForContext(ctx);
				pendingRestore = (meta && pathMatchesCurrent(meta.path)) ? meta : { x: 0, y: 0, path: currentPath() };
				},
			afterRoute: function(ctx) {
				var restore = pendingRestore;
				pendingRestore = null;
				init();

				if (restore && pathMatchesCurrent(restore.path)) {
					restorePositionWhenReady(restore);
					return;
				}
				if (window.location.hash && window.location.hash !== '#') {
					scrollToHashWhenReady(window.location.hash);
					return;
				}
				cancelActiveRestore();
				jumpTo({ x: 0, y: 0 }, true);
				}
		};
	})();

	/**
	 * set fixed required fields parameter for queylix facets searcg
	 * @param {string} hash - hash string from frontend
	 * @param {object} props - properties from routing table
	 */
	WebBaseAprovLV.Utils.prepareQuelixFixedRequiredFields = function(hash, props) {
		var requiredfieldsPrefix = '&requiredfields=';
		var requiredfields = '';
		var ignoredCategoriesSign = '-';
		var fixedAllowedRequiredfieldsValue = props.fixedAllowedRequiredfieldsValue || '';
		var fixedAllowedRequiredfieldsMultipleValue = props.fixedAllowedRequiredfieldsMultipleValue || '';
		var fixedIgnoredRequiredfieldsValue = props.fixedIgnoredRequiredfieldsValue || '';
		var fixedIgnoredRequiredfieldsMultipleValue = props.fixedIgnoredRequiredfieldsMultipleValue || '';
		var fixedAllowedIgnoredRequiredfieldsField = props.fixedAllowedIgnoredRequiredfieldsField || 'publication_categories';

		// look at the pops configuration from routing if predefined allowed or ignored category is setted
		if ((fixedAllowedRequiredfieldsValue || fixedIgnoredRequiredfieldsValue || fixedAllowedRequiredfieldsMultipleValue || fixedIgnoredRequiredfieldsMultipleValue)) {
			if (fixedAllowedRequiredfieldsValue) {
				requiredfields = requiredfields + '(' + fixedAllowedIgnoredRequiredfieldsField + ':' + fixedAllowedRequiredfieldsValue + ')';
			}
			if (fixedAllowedRequiredfieldsMultipleValue) {
				if (fixedAllowedRequiredfieldsMultipleValue.split('|').length > 1 || fixedAllowedRequiredfieldsMultipleValue.split('.').length > 1) {
					requiredfields = requiredfields + fixedAllowedRequiredfieldsMultipleValue;
				}
			}
			if (fixedIgnoredRequiredfieldsValue) {
				requiredfields = requiredfields + ignoredCategoriesSign + '(' + fixedAllowedIgnoredRequiredfieldsField + ':' + fixedIgnoredRequiredfieldsValue + ')';
			}
			if (fixedIgnoredRequiredfieldsMultipleValue) {
				if (fixedIgnoredRequiredfieldsMultipleValue.split('|').length > 1) {
					requiredfields = requiredfields + ignoredCategoriesSign + '(' + fixedIgnoredRequiredfieldsMultipleValue + ')';
				}
			}
		}

		// if some predefined category filter is setted then add it to the search query!!
		if (requiredfields.length > 0) {
			if (!hash.includes('requiredfields')) {
				hash = hash + requiredfieldsPrefix + requiredfields;
			} else {
				hash = hash.replace(/requiredfields=/g, '&requiredfields=' + requiredfields + '.');
			}
		}
		return hash;
	};

	/**
	 * Get news detail page url path part.
	 * @returns {string} The detail page url path, usable for news detail link
	 * @example
	 */
	WebBaseAprovLV.Utils.getNewsDetaiPagelUrlPath = function() {
		// set default news detail page url path
		var newsDetailPageUrlPath = 'news';
		// if special page url is setted in config then use it
		if (WebBaseAprovLV.config && WebBaseAprovLV.config.newsDetailPageUrl) {
			var newsDetailUrlPath = WebBaseAprovLV.config.newsDetailPageUrl;
			// if language specific url path is setted then use it
			if (newsDetailUrlPath[WebBaseAprovLV.lang] && newsDetailUrlPath[WebBaseAprovLV.lang].length > 0) {
				newsDetailPageUrlPath = newsDetailUrlPath[WebBaseAprovLV.lang];
			}
		}
		return newsDetailPageUrlPath;
	};
})();
